import { type IUpdateAdminDto, type INewAdminDto, type IPriceDto, type IFedOrderDto } from '@App/types/adminsTypes'
import { API_URL, ADMINS_URL } from '@Config/config'

import instance from '../instance'

export class AdminsController {
    onGetAdmins() {
        return instance.get(`${API_URL}${ADMINS_URL}`)
    }

    onAddAdminRole(query: string) {
        return instance.post(`${API_URL}${ADMINS_URL}/role${query}`)
    }

    onRemoveAdminRole(query: string) {
        return instance.delete(`${API_URL}${ADMINS_URL}/role${query}`)
    }

    onUpdateAdmin(dto: IUpdateAdminDto) {
        return instance.post(`${API_URL}${ADMINS_URL}/reset-password`, dto)
    }

    onAddAdmin(dto: INewAdminDto) {
        return instance.post(`${API_URL}${ADMINS_URL}/sign-up`, dto)
    }

    onRemoveAdmin(query: string) {
        return instance.delete(`${API_URL}${ADMINS_URL}${query}`)
    }

    onGetPriceActivateDates() {
        return instance.get(`${API_URL}/services/price-dates`)
    }

    onUploadPriceFileCallback(dto: IPriceDto) {
        return instance.post(`${API_URL}/services`, dto)
    }

    onGetPriceDataByDate(date: string) {
        return instance.get(`${API_URL}/services/price?date=${date}`)
    }

    onUploadOrderFileCallback(dto: IFedOrderDto) {
        return instance.post(`${API_URL}/services/parse-federal-services`, dto)
    }

    onChangeDocument(dto: FormData, fileName: string, queries: string) {
        return instance.put(`${API_URL}/storage/${fileName}${queries}`, dto)
    }
}
